module.exports = __webpack_public_path__ + "static/media/CAPESESP.e1ec7ef7.svg";